const GA_ID = process.env.REACT_APP_GA4_ID || "";
const KEY = "dg_analytics_consent";

export const analyticsEnabled = () => Boolean(GA_ID);
export const getConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

let loaded = false;
const loadGtag = () => {
  if (loaded || !GA_ID) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

export const setConsent = (value) => {
  try { localStorage.setItem(KEY, value); } catch { /* storage blocked */ }
  if (value === "granted") loadGtag();
};

export const initAnalytics = () => {
  if (getConsent() === "granted") loadGtag();
};

export const track = (event, params = {}) => {
  if (!loaded || typeof window.gtag !== "function") return;
  window.gtag("event", event, params);
};
